




















import BasePageTemplate from '@/views/templates/tenugui/BasePageTemplate.vue'
import MessageArea from '@/views/molecules/MessageArea.vue'
import PopupFirst from '@/views/templates/tenugui/PopupFirst.vue'

export default
  components: {
    BasePageTemplate
    MessageArea
    PopupFirst
  }

  data: () ->
    showPopup: 0
    message: [
      'CHAORAS®（チャオラス）は'
      '日本の伝統的なものづくりから生み出されるモノのよさを'
      '新しいアイデアと最新技術で現代にマッチさせ、'
      '次世代につなぐ進化した「てぬぐい作り」に'
      'チャレンジするブランドです。'
    ]

  methods: {
    startScrollFire: () ->
      if @showPopup == 0
        @showPopup = 1
      @$emit('scrollFire')
    close_popup: () ->
      @showPopup = 2
    add_point: (point) ->
      @$emit('addPoint', point)
  }
